import {
    createRegisterableComponentWithData,
    Election,
    ElectionDataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { TheRaceWidget, TheRaceWidgetProps } from './TheRaceWidget'
import { TopPartyResults } from '../data'

export interface TheRaceWidgetRouteProps {
    election: Election
    partiesToShow?: number
    providedData?: TopPartyResults
    redirectTo?: string
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export const TheRaceWidgetRegistration = createRegisterableComponentWithData(
    'election-the-race-widget',
    ElectionDataLoader,
    (props: TheRaceWidgetRouteProps, data, { onEvent }) => {
        return <TheRaceWidget {...props} data={data} onEvent={onEvent} />
    },
)
